export function extractSeasonNumber(seasonName: string): string {
  if (!seasonName) return "";
  let name: string = seasonName.toLowerCase();
  // eslint-disable-next-line prefer-destructuring
  name = name.split("season")[1];
  const result: string[] | null = /\d+/.exec(name);
  return result?.length ? result[0] : "";
}
